export default __webpack_public_path__ + "static/Yohana Novi Kristanti-467cfd8b162112a16807a7c218c67096.webp";